export const apiConstants = {
  ListAvailableSlots: 'services/app/TeeSlot/ListAvailableSlots',
};
